module.exports = __webpack_public_path__ + "static/senior-8-15cb58bc916ad22e30a9f1ef490d0f5c.png";